import { create } from 'zustand';
import { apiClient } from '../api/client';
import type { ChatThread } from '../types';

interface ChatUnreadState {
  unreadCount: number;
  refresh: () => void;
}

export const useChatUnread = create<ChatUnreadState>((set) => ({
  unreadCount: 0,
  refresh: () => {
    Promise.all([
      apiClient.get<ChatThread[]>('/chat/threads'),
      apiClient.get<{ count: number }>('/chat/channels/general/unread-count'),
      apiClient.get<{ count: number }>('/chat/channels/grease-trap/unread-count'),
    ]).then(([threads, general, greaseTrap]) => {
      const threadsUnread = threads.data.reduce((sum, t) => sum + t.unreadCount, 0);
      set({ unreadCount: threadsUnread + general.data.count + greaseTrap.data.count });
    }).catch((err) => {
      console.error('Не удалось обновить счётчик непрочитанных сообщений', err);
    });
  },
}));
